import React from 'react';

/**
 * Global application footer.
 *
 * SCE brand: dark background (#101820) with the copyright on the left and the
 * application name on the right. Stacks vertically and centers on small
 * screens for mobile responsiveness.
 */
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="no-print bg-sce-dark text-white">
      <div className="relative flex flex-col sm:block items-center px-4 sm:px-6 py-3 text-xs sm:text-sm text-center">
        <span className="text-gray-300">
          &copy; {year} Southern California Edison
        </span>
        <span className="font-semibold tracking-tight mt-1 sm:mt-0 sm:absolute sm:right-6 sm:top-1/2 sm:-translate-y-1/2">
          LLM Gateway Observability
        </span>
      </div>
    </footer>
  );
}
